const map = "https://res.cloudinary.com/bacf/image/upload/v1736541450/Eraconneckt/map_gol6ci.svg";
const donateImg = "https://res.cloudinary.com/bacf/image/upload/v1736541458/Eraconneckt/donateImg_bz5ytv.png";
const donate_img="https://res.cloudinary.com/bacf/image/upload/v1736541460/Eraconneckt/donate_uwiol8.png";
const outreachImg = "https://res.cloudinary.com/bacf/image/upload/v1736541445/Eraconneckt/outreach_oj6ewe.png";
const partnerImg = "https://res.cloudinary.com/bacf/image/upload/v1736541444/Eraconneckt/partner_v16h6a.png";
const communityDevImg = "https://res.cloudinary.com/bacf/image/upload/v1736541456/Eraconneckt/community-dev_oq0x97.png";
const digitalWorkImg = "https://res.cloudinary.com/bacf/image/upload/v1736541455/Eraconneckt/digital-work_juniyl.png";
const economicDevImg = "https://res.cloudinary.com/bacf/image/upload/v1736541458/Eraconneckt/economic-dev_hzsaua.png";
const hero = "https://res.cloudinary.com/bacf/image/upload/v1736541455/Eraconneckt/digital-work_juniyl.png";
const blogHero = "https://res.cloudinary.com/bacf/image/upload/v1736541478/Eraconneckt/blogHero_nol2ld.png";
const donate = "https://res.cloudinary.com/bacf/image/upload/v1736541460/Eraconneckt/donate_uwiol8.png";
const eraconnecktLogo = "https://res.cloudinary.com/bacf/image/upload/v1736541455/Eraconneckt/eraconneckt-logo_faafiy.svg";
const hand = "https://res.cloudinary.com/bacf/image/upload/v1736541472/Eraconneckt/hand_grfvge.png";
const imageBg = "https://res.cloudinary.com/bacf/image/upload/v1736541465/Eraconneckt/imageBg_dp5195.png";
const missionBg = "https://res.cloudinary.com/bacf/image/upload/v1736541449/Eraconneckt/missionBg_hvbfmj.png";
const bacf = "https://res.cloudinary.com/bacf/image/upload/v1736541449/Eraconneckt/bacf_ltiajj.svg";
const eratek = "https://res.cloudinary.com/bacf/image/upload/v1736541458/Eraconneckt/eratek_qcoc2z.svg";
const gsuite = "https://res.cloudinary.com/bacf/image/upload/v1736541458/Eraconneckt/gsuite_hkpwwi.png";
const kronos = "https://res.cloudinary.com/bacf/image/upload/v1736541436/Eraconneckt/kronos_asm7yl.svg";
const screenshot = "https://res.cloudinary.com/bacf/image/upload/v1736541453/Eraconneckt/Screenshot_2022-05-02_092851_wrat3a.png";
const instagram = "https://res.cloudinary.com/bacf/image/upload/v1736541435/Eraconneckt/instagram_et8xll.svg";
const twitter = "https://res.cloudinary.com/bacf/image/upload/v1736541449/Eraconneckt/twitter_co3uab.svg";
const facebook = "https://res.cloudinary.com/bacf/image/upload/v1736541459/Eraconneckt/facebook_p2cxxw.svg";
const icon_2016 = "https://res.cloudinary.com/bacf/image/upload/v1736541438/Eraconneckt/2016_w9dysw.svg";
const icon_2017 = "https://res.cloudinary.com/bacf/image/upload/v1736541444/Eraconneckt/2017_pic0dh.svg";
const icon_2018  = "https://res.cloudinary.com/bacf/image/upload/v1736541435/Eraconneckt/2018_f54kma.svg";
const icon_2019 = "https://res.cloudinary.com/bacf/image/upload/v1736541435/Eraconneckt/2019_oejmp3.svg";
const icon_2020 = "https://res.cloudinary.com/bacf/image/upload/v1736541441/Eraconneckt/2020_rwi3vz.svg";
const icon_2021 = "https://res.cloudinary.com/bacf/image/upload/v1736541447/Eraconneckt/2021_lwntx5.svg";
const partner_img = "https://res.cloudinary.com/bacf/image/upload/v1736541448/Eraconneckt/partnerImg_xwpjjf.png"
const hero_dey = "https://res.cloudinary.com/bacf/image/upload/v1736541474/Eraconneckt/hero_deyb0z.png"
const outreach_img = "https://res.cloudinary.com/bacf/image/upload/v1736541449/Eraconneckt/outreachImg_ne0dam.png";
const unemployment1 = "https://res.cloudinary.com/bacf/image/upload/v1736546830/Eraconneckt/unemployment-1_jjdmde.svg";
const unemployment2 = "https://res.cloudinary.com/bacf/image/upload/v1736546830/Eraconneckt/unemployment-2_bwk3iy.svg";
const unemployment3 = "https://res.cloudinary.com/bacf/image/upload/v1736546830/Eraconneckt/unemployment-3_gjmhop.svg";
const story = "https://res.cloudinary.com/bacf/video/upload/v1736547201/Eraconneckt/story_jqsnlw.mp4"
export const useExternalMedia =  ()=>{
    return{
        blogHero,
        map,
        donateImg,
        donate_img,
        outreachImg,
        partnerImg,
        communityDevImg,
        digitalWorkImg,
        economicDevImg,
        hero,
        donate,
        eraconnecktLogo,
        hand,
        imageBg,
        missionBg,
        bacf,
        eratek,
        gsuite,
        kronos,
        screenshot,
        instagram,
        twitter,
        facebook,
        icon_2016,
        icon_2017,
        icon_2018,
        icon_2019,
        icon_2020,
        icon_2021,
        partner_img,
   hero_dey, outreach_img, unemployment1, unemployment2, unemployment3, story
    }
}